import Component from '../abstracts/Component';
import TrackingComponent from '../components/TrackingComponent';
import vex from 'vex-js';
import OnDemandLiveRegion from "../utils/OnDemandLiveRegion";

export default class AddToCartComponent extends Component {

  get COMPONENTNAME() {
    return 'AddToCartComponent';
  }

  get SELECTORS() {
    return {
      addToCartBtn: '[data-js-add-to-cart="desktop"]',
      queryId: '[data-algolia-query-id]',
      authenticatedUserToken: '[data-authenticated-user-token]',
      searchIndex: '[data-search-index]',
      addToCartMobileBtn: '[data-js-add-to-cart="mobile"]',
      addToCartError: '[data-js-add-to-cart-error]',
    };
  }

  constructor(compEl) {
    super(compEl);
    this.TrackingComponent = new TrackingComponent();
    this.liveRegion = new OnDemandLiveRegion({
      level: "assertive",
      delay: 1000,
    });
  }

  readDOM() {
    return {
      addToCartBtn: this.$component.querySelector(this.SELECTORS.addToCartBtn),
      addToCartMobileBtn: this.$component.querySelector(this.SELECTORS.addToCartMobileBtn),
      addToCartError: this.$component.querySelector(this.SELECTORS.addToCartError),
    };
  }

  // handle click on add to cart Btn //
  addToCartHandler() {
    if (this.dom.addToCartBtn) {
      this.dom.addToCartBtn.addEventListener("click", (event) => {
        event.preventDefault();
        //get size selected
        let sizeSelected = null;
        // product is uniqueSize
        if (this.dom.addToCartBtn.dataset.uniqueSize === 'true') {
          this.addToCart(this.dom.addToCartBtn.dataset.productCode, this.dom.addToCartBtn);
          this.TrackingComponent.actions.addToCart(this.dom.addToCartBtn.dataset.productCode);
        }
        // product has sizes
        if (this.dom.addToCartBtn.dataset.uniqueSize === 'false') {
          const sizeSelector = document.querySelector('[data-js-component="SizeSelectorComponent"]');
          if (sizeSelector) {
            sizeSelected = sizeSelector.querySelector("input:checked");
            if (sizeSelected) {
              sizeSelected = sizeSelected.dataset.productCode;
            }
          }
          // handle no size selected
          if (!sizeSelected && this.dom.addToCartError) {
            this.dom.addToCartError.classList.remove("hidden");
          }
          // handle added to cart
          if (sizeSelected) {
            if (this.dom.addToCartError) {
              this.dom.addToCartError.classList.add("hidden");
            }
            this.addToCart(sizeSelected, this.dom.addToCartBtn);
            this.TrackingComponent.actions.addToCart(sizeSelected);
          }
        }
      });
    }
    if (this.dom.addToCartMobileBtn) {
      this.dom.addToCartMobileBtn.addEventListener("click", (event) => {
        event.preventDefault();
        //get size selected
        let sizeSelected = null;
        // product is uniqueSize
        if (this.dom.addToCartMobileBtn.dataset.uniqueSize === 'true') {
          this.addToCart(this.dom.addToCartMobileBtn.dataset.productCode, this.dom.addToCartMobileBtn);
          this.TrackingComponent.actions.addToCart(this.dom.addToCartMobileBtn.dataset.productCode);
        }
        // product has sizes
        if (this.dom.addToCartMobileBtn.dataset.uniqueSize === 'false') {
          const sizeSelector = document.querySelector('[data-js-component="SizeSelectorComponent"]');
          if (sizeSelector) {
            sizeSelected = sizeSelector.querySelector("input:checked");
            if (sizeSelected) {
              sizeSelected = sizeSelected.dataset.productCode;
            }
          }
          // handle no size selected --> scroll to sizes
          if (!sizeSelected) {
            sizeSelector.scrollIntoView({behavior: "smooth", block: "center",});
            this.$emit(this.$customEvents.SIZES_EVENTS.noSizeSelected);
          }
          // handle added to cart
          if (sizeSelected) {
            this.addToCart(sizeSelected, this.dom.addToCartMobileBtn);
            this.TrackingComponent.actions.addToCart(sizeSelected);
          }
        }
      });
    }
  }

  // add to cart server calls //
  addToCart(sizeCode, addToCartBtn) {
    addToCartBtn.classList.add("--loading");
    const queryId = document.querySelector(this.SELECTORS.queryId)?.dataset?.algoliaQueryId;
    let url = addToCartBtn.dataset.href + '?code=' + sizeCode;

    // SEND EXTRA PARAMETERS IF ALGOLIA IS ENABLED
    if(queryId && queryId != ''){
      let authenticatedUserToken = document.querySelector(this.SELECTORS.authenticatedUserToken)?.dataset?.authenticatedUserToken;
      let userToken = document.querySelector('[data-user-token]')?.dataset?.userToken;
      let indexName = document.querySelector(this.SELECTORS.searchIndex)?.dataset?.searchIndex;
      url = addToCartBtn.dataset.href + '?code=' + sizeCode + '&queryId=' + queryId + '&authenticatedUserToken=' + authenticatedUserToken + '&userToken=' + userToken + '&indexName=' + indexName;
    }
    fetch(url, {method: 'POST'})
      .then(res => {
        if (res.ok) {
          addToCartBtn.classList.remove("--loading");
          res.text().then(text => {
            if (text == 650) {
              //show exceeded cart quantity modal
              const remoteHref = addToCartBtn.dataset.exceededCartQty;
              const url = remoteHref + sizeCode;
              this.liveRegion.sayMessage(addToCartBtn.dataset.labelCartError);
              this.openModal(url);
            } else if (text == 651) {
              //show low stock modal
              const remoteHref = addToCartBtn.dataset.lowstockCartQty;
              const url = remoteHref + sizeCode;
              this.openModal(url);
              this.liveRegion.sayMessage(addToCartBtn.dataset.labelCartError);
            } else {
              // if no error occurs then emit event
              this.$emit(this.$customEvents.PRODUCT_EVENTS.addedtocart, {productCode: sizeCode});
              this.liveRegion.sayMessage(addToCartBtn.dataset.labelCartAdded);
            }
          });
          return true;
        } else {
          if (res.status == 510) {
            //show product unavailable modal
            const remoteHref = addToCartBtn.dataset.remoteUnavailable;
            const url = remoteHref + sizeCode;
            const ctx = this;
            fetch(url)
              .then(response => response.text())
              .then(content => {
                vex.open({
                  unsafeContent: content,
                  className: '--functional',
                  closeClassName: 'icon close',
                  showCloseButton: true,
                  afterOpen: function () {
                    this.closeEl.classList.remove('vex-close');
                    ctx.unavailableModalInit(this);
                  }
                });
                ctx.liveRegion.sayMessage(addToCartBtn.dataset.labelCartError);
              })
              .catch(error => console.error(error));
          }
          addToCartBtn.classList.remove("--loading");
          return false;
        }
      })
      .catch(error => console.error(error));
  }

  // modals //
  openModal(url) {
    fetch(url)
      .then(response => response.text())
      .then(content => {
        vex.open({
          unsafeContent: content,
          className: '--functional',
          closeClassName: 'icon close',
          showCloseButton: true,
          afterOpen: function () {
            this.closeEl.classList.remove('vex-close');
          }
        });
      })
      .catch(error => console.error(error));
  }

  unavailableModalInit(modal) {
    const notifyMeBtn = modal.contentEl.querySelector("[data-js-notifyme-btn]");
    const notifyMeForm = modal.contentEl.querySelector("[data-js-notifyForm]");
    const backBtn = modal.contentEl.querySelector('#backBtn');
    const backBtnMain = modal.contentEl.querySelector('#mainBackBtn');
    const confirmSection = modal.contentEl.querySelector('[data-js-confirm]');
    const confirmText = modal.contentEl.querySelector('[data-js-response]');

    backBtn.addEventListener("click", event => {
      modal.close();
    });
    notifyMeBtn.addEventListener("click", event => {
      event.preventDefault();
      backBtn.classList.remove("--primary");
      backBtn.classList.add("--secondary");
      backBtnMain.classList.add('hidden');
      notifyMeForm.classList.remove("hidden");
    });
    notifyMeForm.addEventListener("submit", event => {
      event.preventDefault();
      event.stopPropagation();
      const url = notifyMeForm.getAttribute("action");
      const form = new URLSearchParams(new FormData(notifyMeForm));
      fetch(url,
        {
          method: 'POST',
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: form
        }
      )
        .then(response => {
          if (response.ok) {
            response.text().then( text => {
              backBtn.classList.add("--primary");
              backBtn.classList.remove("--secondary");
              backBtnMain.classList.remove('hidden');
              notifyMeForm.classList.add("hidden");
              notifyMeBtn.classList.add("hidden");
              confirmSection.classList.remove("hidden");
              confirmText.innerHTML = text;
            })
          } else {
            modal.querySelector("[data-js-error]").classList.remove("hidden");
          }
        })
        .catch(error => console.warn(error));
    });
  }

  bindEvents() {
    this.addToCartHandler();
    //open notify me
    this.$on(this.$customEvents.PRODUCT_EVENTS.notifyme, ({event, payload}) => {
      this.dom.addToCartBtn ? this.dom.addToCartBtn.classList.add("hidden") : '';
      this.dom.addToCartMobileBtn ? this.dom.addToCartMobileBtn.classList.add("hidden") : '';
    });
    // close notifyme
    this.$on(this.$customEvents.PRODUCT_EVENTS.notifymeclose, ({event, payload}) => {
      this.dom.addToCartBtn ? this.dom.addToCartBtn.classList.remove("hidden") : '';
      this.dom.addToCartMobileBtn ? this.dom.addToCartMobileBtn.classList.remove("hidden") : '';
    });
    //handel size selected
    this.$on(this.$customEvents.PRODUCT_EVENTS.sizechanged, ({event, payload}) => {
      this.dom.addToCartError ? this.dom.addToCartError.classList.add("hidden") : '';
    });
    //handle addToCart button label change
    this.$on(this.$customEvents.PRODUCT_EVENTS.addedtocart, ({event, payload}) => {
      if(this.dom.addToCartBtn) {
        this.dom.addToCartBtn.querySelector(".custom-button__message").innerHTML = "<i class='icon-check --l'></i>" + this.dom.addToCartBtn.dataset.addedMsg;
        setTimeout(() => {
          this.dom.addToCartBtn.querySelector(".custom-button__message").innerHTML = this.dom.addToCartBtn.dataset.standardMsg;
        }, 3000);
      }
      if(this.dom.addToCartMobileBtn) {
        this.dom.addToCartMobileBtn.querySelector(".custom-button__message").innerHTML = "<i class='icon-check --l'></i>" + this.dom.addToCartMobileBtn.dataset.addedMsg;
        setTimeout(() => {
          this.dom.addToCartMobileBtn.querySelector(".custom-button__message").innerHTML = this.dom.addToCartMobileBtn.dataset.standardMsg;;
        }, 3000);
      }
    })
  }

  render() {
    this.log('Rendering...');
    this.dom = this.readDOM();
    this.bindEvents();
  }
}
